'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _ChatHeadingConfigTypes = require('../constants/ChatHeadingConfigTypes');

exports.default = (0, _immutable.Record)({
  '@type': _ChatHeadingConfigTypes.COMPANY,
  companyLogoUrl: '',
  customChatName: ''
}, 'CompanyChatHeadingConfig');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/records/CompanyChatHeadingConfig.js
// module id = 924
// module chunks = 2 3